<ion-app class="mobile-adapter" style="align-items: center;">
    <ion-header class="max-560">
        <app-navigation></app-navigation>
    </ion-header>

    <ion-content class="ion-padding max-560">
        <router-outlet></router-outlet>
        <app-action-footer></app-action-footer>
    </ion-content>


    <ion-footer class="max-560">
        <ion-toolbar>
        <app-footer></app-footer>
    </ion-toolbar>
    </ion-footer>
</ion-app>

<app-loading></app-loading>
<app-notification-modal></app-notification-modal>
<!--
<div class="mobile-adapter">
    <div class="mobile-view">
        <app-navigation></app-navigation>
        <router-outlet></router-outlet>
        <app-action-footer></app-action-footer>
        <app-footer></app-footer>
    </div>
</div>
<app-loading></app-loading>
<app-notification-modal></app-notification-modal>
-->
